// 회사 내용. 땡스 아치브랑 말본 6451에 있는 사진 조합해서 회사 페이지 만들기.
// 회사 페이지 컴포넌트


function About(){

    return (

        <div className="container" style={{marginTop:"50px"}}>

            <div className="col-md-12">
                <img src="/img/malbon1.jpg" style={{width:"100%"}}/>
                <img src="/img/malbon2.jpg"  style={{width:"100%"}}/>
            </div>
    
        </div>

    )
    

}


export default About